import { Injectable } from '@angular/core';
import { AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/storage';
import { Observable, Subscription } from 'rxjs';
import { AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
import { ServerService } from './server.service';
import { map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { UtilityService } from './utility.service';


@Injectable({
    providedIn: 'root'
  })

export class MatchmakingService {

    userExist: boolean;
    task: AngularFireUploadTask;
    ref: AngularFireStorageReference;
    private _arrQueueEasy: Array<any> = [];
    private _arrQueueMedium: Array<any> = [];
    private _arrQueueHard: Array<any> = [];
  
    private _inviteId: string;
    private _isMatch = false;

    constructor(
        private afStore: AngularFirestore,
        private _srv: ServerService,
        private authSrv: AuthenticationService,
        private _utilSrv: UtilityService
        ) {
    }

    getUsers(): Observable<DocumentChangeAction<any>[]> {
        return this.afStore.collection('users', ref => ref.orderBy('nickname')).snapshotChanges();
    }

    getQueueEasy(): Observable<any> {
        return this.afStore.collection('queue').doc('easy').collection('users').snapshotChanges();
    }

    getQueueMedium(): Observable<any> {
        return this.afStore.collection('queue').doc('medium').collection('users').snapshotChanges();
    }

    getQueueHard(): Observable<any> {
        return this.afStore.collection('queue').doc('hard').collection('users').snapshotChanges();
    }

    isNickname(arUsers, nickname){
        this.userExist = false;
        for (let i = 0; i < arUsers.length; i++){
            if (arUsers[i].nickname === nickname.value) {
                return this.userExist = true;
            }
        }

    }

    statusMatch(): Observable<any> {
        return this.afStore.collection('queue').doc(this._utilSrv.difficulty).collection('users').doc(this.authSrv.user.uid).snapshotChanges();
    }

    get isMatch() {
        return this._isMatch;
    }

    set isMatch(isMatch: boolean) {
        this._isMatch = isMatch;
    }

    getNotifyInbox(userId): Observable<any> {
        return this.afStore.collection('inbox').doc(userId).collection('invites').snapshotChanges();
    }

    sendInvite(difficulty: string, nickname: string):Observable<any> {
        return this._srv.sendInvite(difficulty, nickname).pipe(map(res => {
            return res;
        }));
    }
    
    getStatusInvite(userId: string, inviteId: string): Observable<any> {
        return this.afStore.collection('inbox').doc(userId).collection('invites').doc(inviteId).snapshotChanges();
    }

    confirmInvite(inviteId, response, reason) {
        return this._srv.respondInvite(inviteId, response, reason).pipe(map(res => {
            return res;
        }));
    }

    confirmRandomMatch(difficulty) {
        return this._srv.startConfirmMatch(difficulty).pipe(map(res => {
            return res;
        }));
    }

    startMatchmaking(difficulty) {
        return this._srv.startMatchmakingFunction(difficulty).pipe(map(res => {
            return res;
        }));
    }

    stopMatchmaking(difficulty) {
        return this._srv.endMatchmakingFunction(difficulty).pipe(map(res => {
            return res;
        }));
      }

    get inviteId() {
        return this._inviteId;
    }

    set inviteId(newInvite: string) {
        this._inviteId = newInvite;
    }

    get arrQueueEasy() {
        return this._arrQueueEasy;
    }

    set arrQueueEasy(arrQueueEasy: Array<any>) {
        this._arrQueueEasy = arrQueueEasy;
    }

    get arrQueueMedium() {
        return this._arrQueueMedium;
    }

    set arrQueueMedium(arrQueueMedium: Array<any>) {
        this._arrQueueMedium = arrQueueMedium;
    }

    get arrQueueHard() {
        return this._arrQueueHard;
    }

    set arrQueueHard(arrQueueHard: Array<any>) {
        this._arrQueueHard = arrQueueHard;
    }

}
